@use '@lib/assets/styles/main.scss' as *;

$imageSize: 32px;

.userWrap {
  padding-left: $imageSize + 8px;
  position: relative;
}

.userWrapDisabled {
  @extend %disabledGrayscale;
}

.userAvatar {
  position: absolute;
  top: 2.5px;
  left: 0;
  width: $imageSize;
  img, svg {
    @extend %userAvatarImage;
    width: $imageSize;
    height: $imageSize;
  }
}

.userInfo {
  min-height: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > * {
    display: block;
    word-break: break-word;
    & + * {
      margin-top: -4px;
    }
  }
}

.userEmail {
  color: $gray500;
}
